import type { Editor } from '@tiptap/react';
import {
  type PublishedEditorUpdateEvents,
  TeaPubSub,
  type UpdateEvents,
} from './tea-pub-sub.ts';

export class TeaBroadcaster {
  id: string;
  editor: Editor;

  constructor(id: string, editor: Editor) {
    this.id = id;
    this.editor = editor;

    const editorEvents: (keyof UpdateEvents)[] = [
      'update',
      'selectionUpdate',
      'focus',
    ];

    for (const event of editorEvents) {
      editor.on(event, (e) => {
        this.publishEditorState(e.editor, event);
      });
    }

    this.subscribeToListenerCreation();
    this.publishEditorState();
  }

  subscribeToListenerCreation() {
    const clientSubscriber = TeaPubSub.instance.subscribe(
      'listener-created',
      this.id,
      (data) => {
        if (data.id === this.id) {
          this.publishEditorState(this.editor, 'listener-created');
        }
      },
    );

    this.editor.on('destroy', () => {
      TeaPubSub.instance.unsubscribe('listener-created', clientSubscriber.id);
    });
  }

  publishEditorState(
    editor: Editor = this.editor,
    event: PublishedEditorUpdateEvents = null,
  ) {
    TeaPubSub.instance.publish('editor-updated', {
      id: this.id,
      editor,
      event,
    });
  }

  publishSaving(
    payload: { html: string; document: object },
    editor: Editor = this.editor,
  ) {
    TeaPubSub.instance.publish('saving', {
      id: this.id,
      editor,
      ...payload,
    });
  }

  publishSaved(
    payload: { html: string; document: object },
    editor: Editor = this.editor,
  ) {
    TeaPubSub.instance.publish('saved', {
      id: this.id,
      editor: editor,
      ...payload,
    });
  }
}
